import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: ({keys,length}) => ({
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: keys + 1 !== length && '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingBottom:  20, 
        paddingTop: 20
    })

}))

const AdminView = (props) => {
    const {login, keys, length} = props
    const classes = useStyles({keys, length});

    return (
        <span key={keys} className={classes.root}>
            {login}
        </span>
    )
}

export default AdminView;